// extracted by mini-css-extract-plugin
export var cardIcon = "_7g-4";
export var checkboxCard = "_7g-0";
export var checkboxCardSelected = "_7g-3";
export var disabled = "_7g-1";
export var outerBorder = "_7g-2";
export var spacerMedium = "_7g-7";
export var spacerSmall = "_7g-6";
export var spacerXsmall = "_7g-5";